import { render, staticRenderFns } from "./CategoryBadge.vue?vue&type=template&id=02c735b4&scoped=true"
import script from "./CategoryBadge.vue?vue&type=script&lang=js"
export * from "./CategoryBadge.vue?vue&type=script&lang=js"
import style0 from "./CategoryBadge.vue?vue&type=style&index=0&id=02c735b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c735b4",
  null
  
)

export default component.exports